import "core-js/modules/es.array.map.js";
import React from 'react';
import { hasPrivilege, USER_WRITE } from 'utils/privileges';
import { AdminOrHubTextLink } from 'components/AdminOrHubLink';
import DetailsDropdown from 'components/ContentInfo/DropdownInfo';
function TeamManagersDropdown(_ref) {
  var managers = _ref.managers,
    children = _ref.children;
  var areManagersVisible = hasPrivilege(USER_WRITE);
  var title = 'managers';
  var menuItems = managers.map(function (manager) {
    var id = manager.id,
      displayName = manager.displayName;
    var link = "/users?search=".concat(encodeURIComponent("id:".concat(id)));
    return /*#__PURE__*/React.createElement(AdminOrHubTextLink, {
      bold: true,
      key: id,
      link: link
    }, displayName);
  });
  return /*#__PURE__*/React.createElement(DetailsDropdown, {
    titleKey: title,
    listItems: menuItems,
    isDisabled: !areManagersVisible
  }, children);
}
export default TeamManagersDropdown;